module.exports = __webpack_public_path__ + "static/arwes-system-@2x-4dae77c9c79e98a3b28aab518b6a40fb.jpg";